module.exports = __webpack_public_path__ + "media/icons/switch_white-b195831d.png";